import script from "./PartenaireDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./PartenaireDetails.vue?vue&type=script&setup=true&lang=js"

import "./PartenaireDetails.vue?vue&type=style&index=0&id=114aa6ce&lang=css"

const __exports__ = script;

export default __exports__